import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Toggles a loader scoped to {@link AppLayoutComponent}'s main content area (not the nav shell),
 * so users can still use navigation while long-running work runs over the outlet.
 */
@Injectable({ providedIn: 'root' })
export class AppContentLoaderService {
  private readonly visible$ = new BehaviorSubject(false);

  readonly loading$: Observable<boolean> = this.visible$.asObservable();

  show(): void {
    this.visible$.next(true);
  }

  hide(): void {
    this.visible$.next(false);
  }

  /** Clears loading state (same as hide; matches prior fullscreen spinner API). */
  reset(): void {
    this.visible$.next(false);
  }
}
